// extracted by mini-css-extract-plugin
export var cls1 = "StarWincon-module--cls1--cc27d";
export var cls10 = "StarWincon-module--cls10--ec41c";
export var cls2 = "StarWincon-module--cls2--3fd3f";
export var cls3 = "StarWincon-module--cls3--d553a";
export var cls4 = "StarWincon-module--cls4--c18b0";
export var cls5 = "StarWincon-module--cls5--d658e";
export var cls6 = "StarWincon-module--cls6--014f7";
export var cls7 = "StarWincon-module--cls7--31f03";
export var cls8 = "StarWincon-module--cls8--b28fc";
export var cls9 = "StarWincon-module--cls9--a000b";
export var container = "StarWincon-module--container--6323e";